import { type ComponentPropsWithRef } from 'react'

import { ButtonText } from '@/components/common/Button'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type DistributiveOmit } from '@/defs/misc'

type Props = {
  label?: string
} & DistributiveOmit<ComponentPropsWithRef<typeof ButtonText>, 'children' | 'label'>

export const ReadMoreLink = ({ label = 'Read More', ...props }: Props) => (
  <ButtonText hover='accent' size='sm' {...props}>
    <IconWithLabel iconAfter='caretRight' iconAfterSize='sm'>
      {label}
    </IconWithLabel>
  </ButtonText>
)
